import { render, staticRenderFns } from "./TextReadMore.vue?vue&type=template&id=2463f32e&"
import script from "./TextReadMore.vue?vue&type=script&lang=js&"
export * from "./TextReadMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports